import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../../assets/scss/notes.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import SpinnerForNoteComponent from "../../../../@core/components/spinner/Fallback-spinnerForNote";
import { useFormik } from "formik";
import { Row, Col } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useLocation, useHistory } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import Repository from "../../../../configs/axios/repository";
import RouteLeavingGuard from "../../../../components/RouteLeavingGuard/routeLeavingGuard";
import { filterFlashcardJson } from "../../../../utility/helpers/filterJson";
import { filterAndSplitJsonChoice } from "../../../../utility/helpers/filterJson";
import { filterAndSplitJsonWritten } from "../../../../utility/helpers/filterJson";
import Modal from "react-modal";
import x_mark from "../../../../assets/images/courses/group.svg";
import warning from "../../../../assets/images/notes/warning.png";
import checked from "../../../../assets/images/notes/checked.png";
import loading from "../../../../assets/images/notes/loading.gif";
import pending from "../../../../assets/images/notes/writing-loading.gif";
import SpechToText from "./spechToText";
import { handleNote } from "../../../../redux/layout";
import {
  convertFromHTML,
  convertToRaw,
  EditorState,
  ContentState,
} from "draft-js";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { original } from "@reduxjs/toolkit";

const dropzoneStyles = {
  border: "2px dashed #cccccc",
  borderRadius: "4px",
  padding: "20px",
  textAlign: "center",
  cursor: "pointer",
};

const customStyles = {
  content: {
    top: "50%",
    left: "58%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    background: "#fff 0% 0% no-repeat padding-box",
    padding: "20px 30px",
    width: "45%",
    zIndex: "9000",
    maxHeight: "600px",
  },
};

const CreateNote = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const locationState = useLocation();
  let token = JSON.parse(localStorage.getItem("userData"));
  const [loadingData, setLoadingData] = useState(false);
  const [loadingForSummerize, setLoadingForSummerize] = useState(true);
  const [uploadFile, setUploadFile] = useState(null);
  const [findUserLoading, setFindUserLoading] = useState(false);
  const [isSubscription, setIsSubscription] = useState(null);
  const [isProcess, setIsProcess] = useState(false);
  const [showProcessMsg, setShowProcessMsg] = useState(false);
  const [showDraft, setShowDraft] = useState(false);
  const [text, setText] = useState("");
  const [onlytext, setOnlyText] = useState("");
  const [loadingFlashData, setLoadingFlashData] = useState(true);
  const [loadingChoiceData, setLoadingChoiceData] = useState(true);
  const [loadingWrittenData, setLoadingWrittenData] = useState(true);
  const [onStop, setOnStop] = useState(false);

  const [isCreateFlashData, setIsCreateFlashData] = useState(false);
  const [isCreateChoiceData, setIsCreateChoiceData] = useState(false);
  const [isCreateWrittenData, setIsCreateWrittenData] = useState(false);

  const [pendingFlashcard, setPendingFlashcard] = useState(false);
  const [pendingChoice, setPendingChoice] = useState(false);
  const [pendingWritten, setPendingWritten] = useState(false);
  const [noteType, setNoteType] = useState("regular");
  const [startLoadingForSummerize, setStartLoadingForSummerize] =
    useState(true);

  const [modifiedBlobAudio, setModifiedBlobAudio] = useState(null);

  const [isOpen, setIsOpen] = React.useState(false);
  const queryParameters = new URLSearchParams(window.location?.search);
  const course_id =
    queryParameters?.get("course_id") == null
      ? null
      : Number(queryParameters?.get("course_id"));
  let courseName = locationState.state?.courseName;
  // *********************************
  const [isRecording, setIsRecording] = useState(false);
  const [transcribe, setTranscribe] = useState(false);
  const [isRecorder, setIsRecorder] = useState(false);
  const [isSummeryTab, setIsSummeryTab] = useState(false);
  const [isSummerized, setIsSummerized] = useState(false);
  const [summarizedText, setSummarizedText] = useState(null);
  const [originalText, setOriginalText] = useState(null);
  const [noteData, setNoteData] = useState(null);
  const [isCancelRecording, setIsCancelRecording] = useState(false);
  // const [beforeSummarizedText, setBeforeSummarizedText] = useState(null);
  const [contentEditor, setContentEditor] = useState();
  // ***************************************
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [htmlText, setHtmlText] = useState("");

  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    const currentContent = newEditorState.getCurrentContent();
    const rawContentState = convertToRaw(currentContent);

    const plainText = currentContent.getPlainText("\u0001");
    // Convert the raw content state to HTML
    const html = draftToHtml(rawContentState);
    setHtmlText(html);
    setOnlyText(plainText);

    if (isSummeryTab) {
      setSummarizedText(html);
    } else {
      if (
        (noteType == "transcription" ||
          noteType == "upload" ||
          noteType == "mixed") &&
        plainText != ""
      ) {
        setNoteType("mixed");
        setUploadFile(null);
      } else {
        setNoteType("regular");
      }
      setOriginalText(html);
      formik.setFieldValue("notes", plainText);
      setIsSummerized(false);
    }
  };

  const updateEditor = (htmlText) => {
    // Convert the HTML string to ContentState using convertFromHTML
    const contentStateFromHTML = convertFromHTML(htmlText);
    const contentState = ContentState.createFromBlockArray(
      contentStateFromHTML.contentBlocks,
      contentStateFromHTML.entityMap
    );

    // Create a new EditorState using the ContentState
    const initialEditorState = EditorState.createWithContent(contentState);

    // Set the new EditorState as the current editor state
    setEditorState(initialEditorState);
  };

  // ************************
  const formik = useFormik({
    initialValues: {
      notes: "",
      title: "",
      description: "",
    },
    validate: (values) => {
      const errors = {};

      if (modifiedBlobAudio == null) {
        if (originalText?.length < 100) {
          errors.notes = "Your note must contain at least 100 characters.";
        }
      }

      // if (!values.title) {
      //     errors.title = "Required field";
      // }

      return errors;
    },
    onSubmit: async (values) => {
      // formik.setFieldValue("notes", htmlText);
      handleSubmit(values);
    },
  });
  const createFlashcard = async (data) => {
    let array = null;
    setLoadingFlashData(true);
    setPendingFlashcard(true);
    for (let i = 0; i <= 10; i++) {
      let dataChat = {
        count: null,
        messages: data?.summary,
      };
      const resultChat = await Repository.postRequest(
        `api/flashcards/getChatCompletion`,
        dataChat
      );
      array = filterFlashcardJson(resultChat.data.data.getChatCompletionData);

      if (typeof array == "object" && array[0] != undefined) {
        break;
      }
    }

    if (array[0] != undefined) {
      const resultFlashcard = await Repository.postRequest(
        `api/flashcards/createFlashcards`,
        {
          flashcard_name: data.title,
          notes: data.summary,
          flashcard_content: JSON.stringify(array),
          note_id: {
            note_id: data.note_id,
          },
        }
      );

      if (resultFlashcard.data?.success == true) {
        setLoadingFlashData(false);
        setIsCreateFlashData(true);
        return true;
      } else {
        setLoadingFlashData(false);
        setIsCreateFlashData(false);
        return false;
      }
    } else {
      setLoadingFlashData(false);
      setIsCreateFlashData(false);
      return false;
    }
  };
  const createChoiceTest = async (data) => {
    let array = null;
    setPendingChoice(true);
    setLoadingChoiceData(true);
    for (let i = 0; i <= 10; i++) {
      let modifiedText = data.summary.replace(
        /[^a-zA-Z0-9\s\"\,\.\-\+\/\=\*]/g,
        ""
      );
      let dataChat = {
        count: "",
        messages: modifiedText,
        testType: "choice",
      };

      const resultChat = await Repository.postRequest(
        `api/test/getChatCompletion`,
        dataChat
      );

      array = filterAndSplitJsonChoice(
        resultChat.data.data.getChatCompletionData
      );

      if (typeof array == "object" && array[0] != undefined) {
        break;
      }
    }
    if (array[0] != undefined) {
      const resultChoiceTest = await Repository.postRequest(
        `api/test/createMultipleChoiceTest`,
        {
          test_name: data.title,
          test_content: JSON.stringify(array),
          test_prompt: data.summary,
          is_result: false,
          test_type: "choice",
          note_id: {
            note_id: data.note_id,
          },
        }
      );

      if (resultChoiceTest.data.success == true) {
        setLoadingChoiceData(false);
        setIsCreateChoiceData(true);
        return true;
      } else {
        setLoadingChoiceData(false);
        setIsCreateChoiceData(false);
        return false;
      }
    } else {
      setLoadingChoiceData(false);
      setIsCreateChoiceData(false);
      return false;
    }
  };
  const createWrittenTest = async (data) => {
    let array = null;
    setPendingWritten(true);
    setLoadingWrittenData(true);
    for (let i = 0; i <= 12; i++) {
      let modifiedText = data.summary.replace(
        /[^a-zA-Z0-9\s\"\,\.\-\+\/\=\*]/g,
        ""
      );
      let dataChat = {
        count: "",
        messages: modifiedText,
        testType: "written",
      };

      const resultChat = await Repository.postRequest(
        `api/test/getChatCompletion`,
        dataChat
      );

      array = filterAndSplitJsonWritten(
        resultChat.data.data.getChatCompletionData
      );

      if (typeof array == "object" && array[0] != undefined) {
        break;
      }
    }
    if (array[0] != undefined) {
      const resultWrittenTest = await Repository.postRequest(
        `api/test/createWrittenTest`,
        {
          test_name: data.title,
          test_content: JSON.stringify(array),
          test_prompt: data.summary,
          is_result: false,
          test_type: "written",
          note_id: {
            note_id: data.note_id,
          },
        }
      );
      setLoadingWrittenData(false);
      if (resultWrittenTest.data.success == true) {
        setIsCreateWrittenData(true);
        return true;
      } else {
        setIsCreateWrittenData(false);
        return false;
      }
    } else {
      setLoadingWrittenData(false);
      setIsCreateWrittenData(false);
      return false;
    }
  };

  const createExercises = async (data) => {
    let resultChoice;
    let resultWritten;
    let resultFlash;
    if (!isCreateFlashData) {
      resultFlash = await createFlashcard(data);
    } else {
      resultFlash = true;
    }
    if (
      resultFlash === true ||
      resultFlash === false ||
      !isCreateChoiceData ||
      !isCreateWrittenData
    ) {
      if (!isCreateChoiceData) {
        resultChoice = await createChoiceTest(data);
      } else {
        resultChoice = true;
      }
      if (
        resultChoice === true ||
        resultChoice === false ||
        !isCreateWrittenData
      ) {
        if (!isCreateWrittenData) {
          resultWritten = await createWrittenTest(data);
        } else {
          resultWritten = true;
        }
      }
    }
    setIsProcess(false);

    if (resultChoice && resultWritten && resultFlash) {
      setIsOpen(false);
      formik.setFieldValue("title", "");
      formik.setFieldValue("description", "");
      formik.setFieldValue("notes", "");
      setOriginalText("");
      setShowDraft(false);

      allSuccess();
      return true;
    }
  };
  const allSuccess = () => {
    Swal.fire({
      title: "The note has been successfully created.",
      icon: "success",
      confirmButtonColor: "#16285e",
    }).then((res) => {
      if (res.isConfirmed) {
        if (course_id) {
          history.push({
            pathname: "/courseDetails",
            search: `course_id=${course_id}`,
            state: { courseName },
          });
        } else {
          history.push("/home");
        }
      } else {
        setIsCreateFlashData(false);
        setIsCreateChoiceData(false);
        setIsCreateWrittenData(false);
        setShowDraft(false);
      }
    });
  };
  const checkSummarize = async (props) => {
    if (!isSummerized) {
      let rezultSummarize = await summarizNote("notLoad");
      if (rezultSummarize != undefined) {
        return rezultSummarize;
      }
    } else {
      return summarizedText;
    }
  };
  const handleSubmit = async (values) => {
    let noteData = values;
    if (!values.title) {
      const contentState = editorState.getCurrentContent();

      // Get the first block from the content state
      const firstBlock = contentState.getFirstBlock();

      // Get the text from the first block
      const text = firstBlock.getText();

      // Split the text into words and extract the first three words
      const words = text.split(" ");
      const firstThreeWords = words.slice(0, 3).join(" ");
      formik.setFieldValue("title", firstThreeWords);
      noteData = {
        ...values,
        title: firstThreeWords,
        notes: originalText,
      };
    }
    if (isRecording) {
      setOnStop(true);
    }
    if (
      Number(originalText ? originalText.length : noteData.notes.length) >
      Number(194582)
    ) {
      Swal.fire({
        title: "The original note is quite long, please shorten it.",
        icon: "warning",
        confirmButtonColor: "#16285e",
      });
    } else {
      setShowDraft(true);
      setShowProcessMsg(false);
      setIsProcess(true);
      setIsOpen(true);
      let rezultSummarize = await checkSummarize();

      if (rezultSummarize != undefined) {
        let data = {
          title: noteData.title,
          notes: originalText ? originalText : noteData.notes,
          summary: rezultSummarize ? rezultSummarize : summarizedText,
          description: values.description,
          course: course_id,
          isRecorder: isRecorder,
          note_type: noteType,
        };

        const result = await Repository.postRequest(
          `api/notes/createNotes`,
          data
        );

        setIsRecorder(false);
        setNoteData(result.data.data);
        if (result.data.success == true) {
          setLoadingData(true);
          setPendingFlashcard(false);
          setPendingChoice(false);
          setPendingWritten(false);
          setIsOpen(true);
          setOnStop(false);
          createExercises(result.data.data);
        } else {
          setIsOpen(false);
          setShowDraft(false);
          if ((result.data.data = "Data too long for column 'title")) {
            Swal.fire({
              title: "Data too long for column title.",
              icon: "warning",
              confirmButtonColor: "#16285e",
            });
          }
        }
      }
    }
  };

  const onDrop = useCallback(
    async (acceptedFiles) => {
      const formData = new FormData();
      formData.append("files", acceptedFiles[0]);
      setUploadFile(formData);

      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}api/notes/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": process.env.REACT_APP_API_KEY,
            Authorization: `Bearer ${token.access_token}`,
          },
        }
      );

      if (response.data.success == true) {
        if (
          (noteType == "transcription" || noteType == "mixed") &&
          onlytext != ""
        ) {
          setNoteType("mixed");
          setUploadFile(null);
        } else {
          setNoteType("upload");
        }
        if (htmlText != null) {
          setOriginalText(originalText + response.data.data);
          setHtmlText(originalText + response.data.data);
          updateEditor(originalText + response.data.data);
        } else {
          setOriginalText(response.data.data);
          updateEditor(response.data.data);
        }
      } else {
        Swal.fire({
          text: "Unsupported file type!",
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
      }
    },
    [
      token.access_token,
      originalText,
      htmlText,
      setOriginalText,
      setHtmlText,
      updateEditor,
    ]
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const summarizNote = async (props) => {
    if (props == "loading") {
      setLoadingForSummerize(false);
    }

    setLoadingData(false);
    let sumerrixedText = "";
    if (uploadFile) {
      const result_api = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}api/notes/summarizer_api`,
        uploadFile,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": process.env.REACT_APP_API_KEY,
            Authorization: `Bearer ${token.access_token}`,
          },
        }
      );

      if (result_api.data.success) {
        setIsSummerized(true);
        sumerrixedText = result_api.data.data;
        setSummarizedText(result_api.data.data);
        updateEditor(result_api.data.data);
      }
    } else {
      const result = await Repository.postRequest(`api/notes/summarizNote`, {
        notes: originalText,
      });
      if (result.data.success) {
        setIsSummerized(true);
        sumerrixedText = result.data.data.summarizedText;
        setSummarizedText(result.data.data.summarizedText);
        updateEditor(result.data.data.summarizedText);
      }
    }

    setLoadingData(true);
    setLoadingForSummerize(true);
    setIsSummeryTab(true);
    return sumerrixedText;
  };
  function closeModal() {
    setIsCreateFlashData(false);
    setIsCreateChoiceData(false);
    setIsCreateWrittenData(false);
    setIsCreateFlashData(false);
    setShowDraft(false);
    setIsOpen(false);
  }
  function closeNote() {
    if (isProcess) {
      setShowProcessMsg(true);
    } else {
      closeModal();
    }
  }
  useEffect(() => {
    if (!isSummerized && isSummeryTab && htmlText != "") {
      summarizNote("loading");
      setIsSummerized(true);
    } else if (isSummerized) {
      if (isSummeryTab) {
        updateEditor(summarizedText);
      } else {
        updateEditor(originalText);
      }
    }
  }, [isSummeryTab]);

  useEffect(() => {
    if (!isSummeryTab) {
      setOriginalText(htmlText);
      dispatch(handleNote(htmlText));
    }
  }, [htmlText]);

  const findThisUserData = async () => {
    setFindUserLoading(false);
    const result = await Repository.findByEndPoint(`api/users/findThisUser`);
    if (result.data?.success === true) {
      if (
        result.data.data.stripe_subscription_id == "" ||
        result.data.data.stripe_subscription_id == null
      ) {
        setIsSubscription(false);
      } else {
        setIsSubscription(true);
      }
    }
    setFindUserLoading(true);
  };

  useEffect(() => {
    findThisUserData();
  }, []);

  useEffect(() => {
    if (text != "") {
      updateEditor(originalText);
    }
  }, [originalText]);

  return findUserLoading && loadingForSummerize ? (
    <div className="noteSection">
      <div className="labelInputsStyle">
        <div>
          {isRecording ? (
            <h1 className="recordingProcessMsg">
              Recording in progress. It may take a minute before text displays
              below.
              <br />
              Recording can be paused & resumed by clicking on Smart-Study
              microphone.
            </h1>
          ) : (
            <h1 className="noteTitleNotePg">
              Create note with keyboard entry, file upload (e.g. pdf), or
              clicking on microphone icon.
            </h1>
          )}
        </div>

        <div className="btnsNotesDiv">
          <SpechToText
            isRecording={isRecording}
            isSubscription={isSubscription}
            setText={setText}
            text={text}
            onStop={onStop}
            setOriginalText={setOriginalText}
            originalText={originalText}
            setTranscribe={setTranscribe}
            setIsRecorder={setIsRecorder}
            setIsRecording={setIsRecording}
            setIsSummerized={setIsSummerized}
            setIsSummeryTab={setIsSummeryTab}
            setIsCancelRecording={setIsCancelRecording}
            isCancelRecording={isCancelRecording}
            setEditorState={setEditorState}
            setNoteType={setNoteType}
            noteType={noteType}
            onlytext={onlytext}
          />
          <div>
            {isRecording ? (
              <div style={dropzoneStyles} className="uploadBtn">
                <p>Upload</p>
              </div>
            ) : (
              <div
                {...getRootProps()}
                style={dropzoneStyles}
                className="uploadBtn"
              >
                <input {...getInputProps()} />
                <p>Upload</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <form className="formikEvents" onSubmit={formik.handleSubmit}>
        <Row>
          <Col xl="12" md="12" sm="12" className="mt-2">
            <input
              className="titleNote"
              type="text"
              name="title"
              placeholder="Give your notes a title"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.title}
            />
            <div className="errorMessage mt-2">
              {formik.touched.title && formik.errors.title}
            </div>
          </Col>

          <Col xl="12" md="12" sm="12" className="mt-2">
            <input
              className="titleNote"
              type="text"
              name="description"
              placeholder="Topic"
              maxLength={500}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.description}
            />
            <div id="noteHeaderForm"></div>
          </Col>
          {modifiedBlobAudio ? (
            <Col xl="12" md="12" sm="12" className="mt-2">
              <span>Please save your note to finalize the transcription.</span>
            </Col>
          ) : (
            <Col xl="12" md="12" sm="12" className="mt-2">
              <div id="manualNoteEntry">
                <div className="tabMenuCreateNote">
                  <div className="tabs mt-2">
                    <div
                      className={
                        isSummeryTab ? " original" : "original selectedTab"
                      }
                      onClick={() => {
                        setIsSummeryTab(false);
                      }}
                    >
                      Original
                    </div>
                    <div
                      className={
                        isSummeryTab ? "selectedTab summary" : "summary"
                      }
                      onClick={() => {
                        if (originalText) {
                          isRecording ? "" : setIsSummeryTab(true);
                        }
                      }}
                    >
                      Summary
                    </div>
                  </div>
                  <div className="mt-3">
                    <span>
                      {isSummeryTab
                        ? summarizedText?.length
                        : originalText?.length}
                      /200000
                    </span>
                  </div>
                </div>

                <Editor
                  editorState={editorState}
                  placeholder="Your note must contain at least 100 characters.*"
                  onEditorStateChange={onEditorStateChange}
                  handlePastedText={() => false}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName={
                    showDraft ? "notshowDraft" : "editorClassName"
                  }
                />

                <div className="errorMessage mt-2">
                  {formik.touched.notes && formik.errors.notes}
                </div>
              </div>
            </Col>
          )}
          <Col xl="12" md="12" sm="12">
            <div className="testBtn">
              <button
                onClick={() => {
                  history.push(`/home`);
                }}
                type="button"
                className="btnOkTest"
                disabled={isRecording}
              >
                Back
              </button>
              {isRecording ? (
                <button
                  onClick={() => {
                    setIsCancelRecording(true);
                    formik.setFieldValue("title", "");
                    formik.setFieldValue("description", "");
                    formik.setFieldValue("notes", "");
                  }}
                  type="button"
                  className="btnOkTest"
                >
                  Cancel
                </button>
              ) : (
                ""
              )}
              <button id="saveBtnDiv" type="submit" className="generateTest">
                Generate Tests
              </button>
            </div>
          </Col>
        </Row>
      </form>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={customStyles}
        ariaHideApp={false}
        contentLabel="Example Modal"
      >
        <div className="showNotes">
          <h2>Generating tests</h2>
          <img
            src={x_mark}
            onClick={() => {
              closeNote();
            }}
            className="closeModalImg"
          />
        </div>
        {showProcessMsg ? (
          <div>
            <p className="processMsg">
              Please wait. There are still processes that have not been
              completed yet.
            </p>
          </div>
        ) : (
          ""
        )}

        <div>
          <span>
            This may take a few minutes. Please do not close the window.
          </span>
        </div>
        <div className="mb-5 mt-3 processCreateTests">
          <div className="mb-3 ">
            <span>Summarizing</span>
            <img src={!loadingData ? loading : checked} alt="loading" />
          </div>
          <div className="mb-3 ">
            <span>Flashcards</span>
            <img
              src={
                !pendingFlashcard
                  ? pending
                  : loadingFlashData
                  ? loading
                  : isCreateFlashData
                  ? checked
                  : warning
              }
              alt="loading"
            />
          </div>
          <div className="mb-3 ">
            <span>Multiple choice</span>

            <img
              src={
                !pendingChoice
                  ? pending
                  : loadingChoiceData
                  ? loading
                  : isCreateChoiceData
                  ? checked
                  : warning
              }
              alt="loading"
            />
          </div>

          <div className="mb-3 ">
            <span>Written</span>
            <img
              src={
                !pendingWritten
                  ? pending
                  : loadingWrittenData
                  ? loading
                  : isCreateWrittenData
                  ? checked
                  : warning
              }
              alt="pending"
            />
          </div>
        </div>
        <div className="regenerate">
          {(!isCreateFlashData && pendingFlashcard && !loadingFlashData) ||
          (!isCreateChoiceData && pendingChoice && !loadingChoiceData) ||
          (!isCreateWrittenData && pendingWritten && !loadingWrittenData) ? (
            <button
              onClick={() => {
                createExercises(noteData);
              }}
            >
              Regenerate
            </button>
          ) : (
            ""
          )}
        </div>
      </Modal>
      <RouteLeavingGuard
        when={formik.dirty}
        navigate={(path) => {
          if (history.location.pathname == path) {
            handleResetForm();
          } else {
            history.push(path);
          }
        }}
        shouldBlockNavigation={(location) => {
          if (formik.dirty) {
            return true;
          }
          return false;
        }}
        yes="Yes"
        no="No"
        content={
          <div className="text-center">
            <h5>
              You haven't saved your note. Would you like to finish it before
              leaving the page?
            </h5>
            {/* <p>The referral details will be discarded</p> */}
          </div>
        }
      />
    </div>
  ) : !transcribe ? (
    <div>
      {loadingForSummerize ? (
        <Spinner spiner={true} summarizNote={false} />
      ) : (
        <Spinner spiner={true} summarizNote={true} />
      )}
    </div>
  ) : (
    <div>
      <SpinnerForNoteComponent />
    </div>
  );
};

export default CreateNote;
